import Project from "../main.js";

export class Logos {
	constructor() {
		this.project = new Project();

		this.DOM = {
			swiper: this.project.DOM.body.querySelector('.logos__swiper'),
			swiperPrevBtn: this.project.DOM.body.querySelector('.logos__swiper__button--prev'),
			swiperNextBtn: this.project.DOM.body.querySelector('.logos__swiper__button--next'),
			swiperList: this.project.DOM.body.querySelector('.logos__list'),
			swiperListInner: this.project.DOM.body.querySelector('.logos__list__inner'),
		}

		if(!this.DOM.swiper) {
			return null;
		}

		this.init();
	}

	init() {
		this.handleEvents()
	}

	handleEvents() {
		this.DOM.swiperPrevBtn.addEventListener('click', () => this.scroll(-1));
		this.DOM.swiperNextBtn.addEventListener('click', () => this.scroll(1));

		this.DOM.swiperList.addEventListener('scroll', () => this.checkEdges());
		this.project.hooks.resize.push(this.checkEdges.bind(this))
	}

	scroll(direction) {
		const delta = direction * this.DOM.swiperList.clientWidth;
		this.DOM.swiperList.scrollBy({ left: delta, behavior: 'smooth' });
	}

	checkEdges() {
		this.DOM.swiperPrevBtn.toggleAttribute('disabled', this.atStartEdge());
		this.DOM.swiperPrevBtn.setAttribute('aria-disabled', this.atStartEdge());

		this.DOM.swiperNextBtn.toggleAttribute('disabled', this.atEndEdge());
		this.DOM.swiperNextBtn.setAttribute('aria-disabled', this.atEndEdge());
	}

	atStartEdge() {
		return this.DOM.swiperList.scrollLeft <= 1;
	}

	atEndEdge() {
		return this.DOM.swiperList.scrollLeft + this.DOM.swiperList.clientWidth >= this.DOM.swiperList.scrollWidth - 1;
	}
}